import { useLiveQuery } from "next-sanity/preview";
import { type IRelated, relatedQuery } from "../queries";

export const useRelatedData = (ids: string[], targetType: string) => {
  return useLiveQuery<IRelated[] | null>(null, relatedQuery, {
    ids,
    targetType,
  });
};
